import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ClinicalAssessmentApi } from '../api/clinicalassessment.api';
import { ClinicalAssessmentData, } from '../../../interfaces/masters/clinicalassessment';
import { HttpParams } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class ClinicalAssessmentService extends ClinicalAssessmentData {
  constructor(private api: ClinicalAssessmentApi) {
    super();
  }

  list<type>(url: string,params?:HttpParams): Observable<type> {
    if(!!params){
      return this.api.list(url,params);
    }
    else{
      return this.api.list(url);
    }
    
  }

  getById<type>(url:string,params?:HttpParams): Observable<type>{
      return this.api.getById(url,params);
  }

  getassessmentById(url:string,params:HttpParams): Observable<any>{
    return this.api.getassessmentById(url,params);
}

  create<type,returnType>(url: string, data:type,params?:HttpParams): Observable<returnType> {
    if(!!params){
      return this.api.add<type,returnType>(url,data,params);
    }
    else{
      return this.api.add<type,returnType>(url,data);

    }

  }
searchList(url: string,data:any): Observable<any> {
   
  return this.api.searchList(url,data);
}
  update(url: string, data:any,params?:HttpParams): Observable<any> {
    if(!!params){
      return this.api.update(url,data,params);
    }
    else{
      return this.api.update(url,data);
    }
    
  }
  updateassessTransaction<type>(url: string, data:type,params:HttpParams){
    return this.api.updateassessTransaction(url,data,params);
  }
  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}



  